import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorksSection() {
  const steps = [{
    num: '01',
    title: 'Identifica',
    desc: 'Detectas la fuga energética en tiempo real con nuestras señales de alerta.'
  }, {
    num: '02',
    title: 'Activa',
    desc: 'Aplicas el Escudo de Vacío (toma menos de 3 minutos, estés donde estés).'
  }, {
    num: '03',
    title: 'Limpia',
    desc: 'Realizas el desanclaje al final del día para asegurar un descanso profundo y reparador.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-navy-900" data-id="element-107">
      <div className="max-w-4xl mx-auto" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-109">
          <h2 className="text-3xl md:text-4xl font-serif text-white mb-6" data-id="element-110">
            Cómo Funciona
          </h2>
          <div className="w-16 h-1 bg-gold-500 mx-auto" data-id="element-111" />
        </motion.div>

        <div className="relative" data-id="element-112">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-[1px] bg-navy-700" data-id="element-113" />

          <div className="grid md:grid-cols-3 gap-8 md:gap-4 relative z-10" data-id="element-114">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="flex flex-col items-center text-center group" data-id="element-115">
                <div className="w-24 h-24 rounded-full bg-navy-950 border-2 border-gold-500/30 flex items-center justify-center mb-6 group-hover:border-gold-400 transition-colors duration-300 shadow-[0_0_15px_rgba(212,175,55,0.1)]" data-id="element-116">
                  <span className="text-3xl font-serif text-gold-400" data-id="element-117">
                    {step.num}
                  </span>
                </div>
                <h3 className="text-xl font-serif text-white mb-3" data-id="element-118">
                  {step.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed px-4" data-id="element-119">
                  {step.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}